export const GET_FAQS = 'GET_FAQS';
export const GET_FAQS_SUCCESS = 'GET_FAQS_SUCCESS';

export type FaqData = {
    sectionLabel: string;
    sections: FaqDataInfo[];
    sectionId: string;
    publicRoute?: boolean;
};

type TableType = {
    columns: string[];
    rows: string[][];
};
export type FaqDataInfo = {
    question: string;
    answer: string;
    linkRequired: string;
    linkUrl?: string;
    tableRequired?: 'Y' | 'N';
    tableData?: TableType;
    tableAnswer?: string;
    listRequired?: 'Y' | 'N';
    addEnv?: 'Y' | 'N';
    linkText?: string;
    listItems?: string[];
};
